<template>
    <div>
        <v-dialog
                v-model="dialog"
                fullscreen
                lazy
        >
           <v-card>
                <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container grid-list-md text-xs-left>
                    <v-card-text>
                        <v-flex d-flex lg12 md12 sm12 xs12>
                            <v-flex d-flex lg12 md12 sm12 xs12 style="text-align: center;">
                                <v-progress-circular
                                        :size="150"
                                        color="primary"
                                        indeterminate
                                ></v-progress-circular>
                            </v-flex>
                        </v-flex>
                    </v-card-text>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  name: 'DialogLoading',
  props: {
    title: {
      type: String,
      default: ' ',
      required: false
    },
    dialog: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
